module.exports = __webpack_public_path__ + "img/ai_profile.ff4551eb.jpg";